:root ._dsp-flex{display:flex;}
:root ._items-stretch{align-items:stretch;}
:root ._fd-column{flex-direction:column;}
:root ._fb-auto{flex-basis:auto;}
:root ._bxs-border-box{box-sizing:border-box;}
:root ._pos-relative{position:relative;}
:root ._minH-0px{min-height:0px;}
:root ._minW-0px{min-width:0px;}
:root ._shrink-0{flex-shrink:0;}
:root ._cur-pointer{cursor:pointer;}
:root ._gap-t-space-med104641{gap:var(--t-space-medium);}
:root ._pt-t-space-med104641{padding-top:var(--t-space-medium);}
:root ._pr-t-space-med104641{padding-right:var(--t-space-medium);}
:root ._pb-t-space-med104641{padding-bottom:var(--t-space-medium);}
:root ._pl-t-space-med104641{padding-left:var(--t-space-medium);}
:root ._fd-row{flex-direction:row;}
:root ._btw-1px{border-top-width:1px;}
:root ._btc-divider{border-top-color:var(--divider);}
:root ._brc-divider{border-right-color:var(--divider);}
:root ._borderBottomColor-divider{border-bottom-color:var(--divider);}
:root ._borderLeftColor-divider{border-left-color:var(--divider);}
:root ._width-10037{width:100%;}
:root ._items-center{align-items:center;}
:root ._borderTopStyle-solid{border-top-style:solid;}
:root ._shrink-1{flex-shrink:1;}
:root ._grow-1{flex-grow:1;}